import { ReactNode } from "react";

import { Flex, Table, Text } from "@mantine/core";

import { Button, Modal } from "components";

export interface PreliminaryComparisonRow {
  key: string;
  label: string;
  source: ReactNode;
  current: ReactNode;
}

interface PreliminaryComparisonModalProps {
  opened: boolean;
  onClose: () => void;
  onApply: () => void;
  title: string;
  emptyText: string;
  fieldLabel: string;
  sourceLabel: string;
  currentLabel: string;
  applyLabel: string;
  cancelLabel: string;
  rows: PreliminaryComparisonRow[];
  showApplyButton?: boolean;
}

export const PreliminaryComparisonModal = ({
  opened,
  onClose,
  onApply,
  title,
  emptyText,
  fieldLabel,
  sourceLabel,
  currentLabel,
  applyLabel,
  cancelLabel,
  rows,
  showApplyButton = true,
}: PreliminaryComparisonModalProps) => (
  <Modal opened={opened} onClose={onClose} title={title} size="lg">
    {rows.length > 0 ? (
      <Table verticalSpacing="md" withColumnBorders>
        <Table.Thead>
          <Table.Tr>
            <Table.Th>
              <Text fw={600} c="var(--mantine-color-primary-6)">
                {fieldLabel}
              </Text>
            </Table.Th>
            <Table.Th>
              <Text fw={600}>{sourceLabel}</Text>
            </Table.Th>
            <Table.Th>
              <Text fw={600}>{currentLabel}</Text>
            </Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {rows.map((row) => (
            <Table.Tr key={row.key}>
              <Table.Td>
                <Text c="var(--mantine-color-primary-6)">{row.label}</Text>
              </Table.Td>
              <Table.Td>{row.source}</Table.Td>
              <Table.Td>{row.current}</Table.Td>
            </Table.Tr>
          ))}
        </Table.Tbody>
      </Table>
    ) : (
      <Text c="dimmed">{emptyText}</Text>
    )}

    <Flex justify={showApplyButton ? "space-between" : "flex-start"} mt="xl">
      <Button variant="outline" color="gray" onClick={onClose}>
        {cancelLabel}
      </Button>
      {showApplyButton && (
        <Button onClick={onApply} disabled={rows.length === 0}>
          {applyLabel}
        </Button>
      )}
    </Flex>
  </Modal>
);

export default PreliminaryComparisonModal;
